import { render, staticRenderFns } from "./ShoppingListProduct.vue?vue&type=template&id=2dd5dde6&"
import script from "./ShoppingListProduct.js?vue&type=script&lang=js&"
export * from "./ShoppingListProduct.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports